import {Outlet, Route, Routes} from "react-router-dom";
import {Urls} from "component/const/Urls";
import PreShort from "./Short/PreShort";
import PreTrans from "./Trans/PreTrans";
import PrePrompt from "./Prompt/PrePrompt";

export const Pre = () => {

    return (<div id={"root-element"}>
        <Routes>
            <Route path={Urls.short} element={<PreShort/>}/>
            <Route path={Urls.trans} element={<PreTrans/>}/>
            <Route path={Urls.prompt} element={<PrePrompt/>}/>
        </Routes>
        <Outlet/>
        {/*<Memo/>*/}
    </div>)
}